import React from 'react';

export interface InputProps {
  label?: string;
  id: string;
  name: string;
  type: string;
  placeholder: string;
  setValue?: React.Dispatch<React.SetStateAction<string | any>>;
  defaultValue?: string;
  disabled?: boolean;
  value?: string;
  className?: string;
  button?: {
    text: string;
    onClick: () => void | Promise<void>;
    disabled?: boolean;
  };
}

export const Input = (props: InputProps) => {
  return (
    <div>
      {props.label && (
        <label htmlFor={props.id} className="block text-sm/6 font-medium text-gray-900 mt-6">
          {props.label}
        </label>
      )}
      <div className="mt-2 sm:flex sm:items-center">
        <div className="w-full min-w-0">
          <input
            disabled={props.disabled}
            id={props.id}
            name={props.name}
            type={props.type}
            placeholder={props.placeholder}
            defaultValue={props.defaultValue}
            value={props.value}
            onChange={(event) => {
              if (props.setValue) {
                props.setValue(event.target.value);
              }
            }}
            className={
              `block w-full rounded-md bg-white px-3 py-1.5 text-base
           text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400
           focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600
           disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500
           disabled:outline-gray-200 sm:text-sm/6 ` + (props.className ?? '')
            }
          />
        </div>
        {props.button && (
          <button
            type="button"
            disabled={props.button.disabled}
            onClick={props.button.onClick}
            className="inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3
                py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline
                focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:ml-3
                sm:mt-0 sm:w-auto"
          >
            {props.button.text}
          </button>
        )}
      </div>
    </div>
  );
};
